import { FormControl } from "baseui/form-control";
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from 'baseui/button';
import { useState } from 'react';
import { Checkbox } from 'baseui/checkbox';
import { VerticalStackPanel } from '../../../../components/Layout/StackPanel';
import { TP_AirHandlingUnit } from '.';
import { useSetObjectValue } from "../../../../hooks/useSetObjectValue";
import { ParagraphMedium } from "baseui/typography";


export const ConfigurationPanel = (props: TP_AirHandlingUnit) => {
    const intl = useIntl();
    const [showSupplyDuct, setShowSupplyDuct] = useSetObjectValue(props.id, props.resourceGroupId, "showSupplyDuct", props.showSupplyDuct, 100);
    const [showExhaustDuct, setShowExhaustDuct] = useSetObjectValue(props.id, props.resourceGroupId, "showExhaustDuct", props.showExhaustDuct, 100);
    const [showTrendPanels, setShowTrendPanels] = useSetObjectValue(props.id, props.resourceGroupId, "showTrendPanels", props.showTrendPanels, 100);
    const handleShowSupplyDuctChanged = (e: any) => {
        setShowSupplyDuct(e.target.checked)
    }
    const handleShowExhaustDuctChanged = (e: any) => {
        setShowExhaustDuct(e.target.checked)
    }
    const handleShowTrendPanelsChanged = (e: any) => {
        setShowTrendPanels(e.target.checked)
    }

    return (
        <VerticalStackPanel>
            <ParagraphMedium>{intl.formatMessage({ id: "P_AirHandling.DisplaySettings", defaultMessage: "Display settings in Overview" })}</ParagraphMedium>
            <FormControl
                label={() => intl.formatMessage({ id: "P_AirHandling.SupplyAir", defaultMessage: "Supply" })}
                caption={() => intl.formatMessage({ id: "P_AirHandling.ShowFansSensorsDescr", defaultMessage: "Show Fans and Sensors" })}
            >
                <VerticalStackPanel>
                    <Checkbox checkmarkType={'toggle'} labelPlacement={'right'} checked={showSupplyDuct} onChange={handleShowSupplyDuctChanged}>{intl.formatMessage({ id: "show", defaultMessage: "show" })}</Checkbox>
                </VerticalStackPanel>
            </FormControl>
            <FormControl
                label={() => intl.formatMessage({ id: "P_AirHandling.ExhaustAir", defaultMessage: "Exhaust" })}
                caption={() => intl.formatMessage({ id: "P_AirHandling.ShowFansSensorsDescr", defaultMessage: "Show Fans and Sensors" })}
            >
                <VerticalStackPanel>
                    <Checkbox checkmarkType={'toggle'} labelPlacement={'right'} checked={showExhaustDuct} onChange={handleShowExhaustDuctChanged}>{intl.formatMessage({ id: "show", defaultMessage: "show" })}</Checkbox>
                </VerticalStackPanel>
            </FormControl>

            <FormControl
                label={() => intl.formatMessage({ id: "charts", defaultMessage: "Charts" })}
                caption={() => intl.formatMessage({ id: "P_AHU.ShowChartsDescr", defaultMessage: "Show Sensor Charts in Overview" })}
            >
                <VerticalStackPanel>
                    <Checkbox checkmarkType={'toggle'} labelPlacement={'right'} checked={showTrendPanels} onChange={handleShowTrendPanelsChanged}>{intl.formatMessage({ id: "show", defaultMessage: "show" })}</Checkbox>
                </VerticalStackPanel>
            </FormControl>

        </VerticalStackPanel>
    )
}
